import * as React from "react";
import { cn } from "@/lib/utils";

interface InputProps
  extends Omit<React.ComponentProps<"input">, "prefix" | "suffix"> {
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, suffix, prefix, ...props }, ref) => {
    return (
      <div
        className={cn(
          "tx-input-container overflow-hidden flex items-center h-10 w-full rounded-md border border-input bg-background px-0 py-0 text-base ring-offset-background",
          className
        )}
      >
        {prefix && <div>{prefix}</div>}

        <input
          ref={ref}
          type={type}
          className="flex w-full border bg-background px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
          {...props}
        />

        {suffix && <div>{suffix}</div>}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
